import { ApplicationApiTagTypes, ApplicationApiUrls } from "@/modules/application/common/enum";
import type {
  ICreatePhoneBankingApplicationRequest,
  IPhoneBankingApplication,
  IUpdatePhoneBankingApplicationRequest,
} from "@/modules/application/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const phoneBankingApplicationApi = createApi({
  reducerPath: "phoneBankingApplicationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [ApplicationApiTagTypes.ApplicationHistory],
  endpoints: (builder) => ({
    createPhoneBankingApplication: builder.mutation<string, ICreatePhoneBankingApplicationRequest>(
      withIdempotency<ICreatePhoneBankingApplicationRequest>(
        ApplicationApiUrls.PhoneBanking
      )),
    updatePhoneBankingApplication: builder.mutation<string, IUpdatePhoneBankingApplicationRequest>(
      {
        query: ({ data, id }) => ({
          url: `${ApplicationApiUrls.PhoneBanking}/${id}`,
          method: "PUT",
          data,
        }),
      }),
    getPhoneBankingApplication: builder.query<IPhoneBankingApplication, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${ApplicationApiUrls.PhoneBanking}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetPhoneBankingApplicationQuery,
  useCreatePhoneBankingApplicationMutation,
  useUpdatePhoneBankingApplicationMutation,
} = phoneBankingApplicationApi;
